import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { fetchClient } from '@nike/fetch-client';
import { BOPIS_LOCATION_TYPE_ID } from './select';
import determineUnitOfMeasure from "../../../../utils/determine-unit-of-measure";
import getWebShellClientLocale from "../../../../utils/get-webshellclient-locale";
import makeQueryKey from "../../../../utils/make-query-key";

/**
 * Fetch store locations
 * @param {Object} param
 * @param {number} param.anchor - The index of the first item to return
 * @param {number} param.count - The number of items to return
 * @param {number} param.maxDistance - The maximum distance in miles
 * @param {number} param.longitude - The longitude of the location
 * @param {number} param.latitude - The latitude of the location
 * @param {string} param.measurementUnits - The measurement units
 * @param {string} param.country - The country
 * @param {string} param.language - The language
 * @returns {Object} - store locations
 */
var fetchStoreLocations = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var latitude, longitude, postalCode, _ref$maxDistance, maxDistance, measurementUnits, country, language, anchor, count, hasCoordinates, geoproximityQuery, search, filters, requestParams;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          latitude = _ref.latitude, longitude = _ref.longitude, postalCode = _ref.postalCode, _ref$maxDistance = _ref.maxDistance, maxDistance = _ref$maxDistance === void 0 ? 50 : _ref$maxDistance, measurementUnits = _ref.measurementUnits, country = _ref.country, language = _ref.language, anchor = _ref.anchor, count = _ref.count;
          hasCoordinates = Boolean(latitude && longitude);
          geoproximityQuery = hasCoordinates ? "\"latitude\":\"".concat(latitude, "\",\"longitude\":\"").concat(longitude, "\",\"iso2Country\":\"").concat(country, "\"") : "\"postalCode\":\"".concat(postalCode, "\", \"iso2Country\":\"").concat(country, "\""); // : `"postalCode":"${postalCode?.toString().substring(0, 5)}", "iso2Country":"${country}"`;
          search = "search=(".concat(window.encodeURIComponent("coordinates=geoProximity={".concat(geoproximityQuery, ",\"maxDistance\":").concat(maxDistance, ",\"measurementUnits\":\"").concat(measurementUnits, "\"} and (storeServices.storeServiceTypeId == \"").concat(BOPIS_LOCATION_TYPE_ID, "\") and (published == true)")), ")");
          filters = "language=".concat(language, "&anchor=").concat(anchor, "&count=").concat(count);
          requestParams = "?".concat(search, "&").concat(filters);
          return _context.abrupt("return", fetchClient("".concat(process.env.NEXT_PUBLIC_API_HOST_NAME, "/store/store_locations/v1/").concat(requestParams)));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function fetchStoreLocations(_x) {
    return _ref2.apply(this, arguments);
  };
}();

/**
 * Fetch store locations
 * @param {Object} params
 * @param {number} params.anchor - The index of the first item to return
 * @param {number} params.count - The number of items to return
 * @param {number} params.maxDistance - The maximum distance in miles
 * @param {number} params.longitude - The longitude of the location
 * @param {number} params.latitude - The latitude of the location
 * @returns {Object} - useQuery object
 */
var getFetchStoreLocationsOptions = function getFetchStoreLocationsOptions() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref3$anchor = _ref3.anchor,
    anchor = _ref3$anchor === void 0 ? 0 : _ref3$anchor,
    _ref3$count = _ref3.count,
    count = _ref3$count === void 0 ? 5 : _ref3$count,
    _ref3$maxDistance = _ref3.maxDistance,
    maxDistance = _ref3$maxDistance === void 0 ? 50 : _ref3$maxDistance,
    longitude = _ref3.longitude,
    latitude = _ref3.latitude,
    postalCode = _ref3.postalCode,
    select = _ref3.select;
  var roundedLongitude = Math.round(100 * Number(longitude)) / 100;
  var roundedLatitude = Math.round(100 * Number(latitude)) / 100;
  var _getWebShellClientLoc = getWebShellClientLocale(),
    country = _getWebShellClientLoc.country,
    language = _getWebShellClientLoc.hreflang;
  var measurementUnits = determineUnitOfMeasure(country === null || country === void 0 ? void 0 : country.toUpperCase());
  return _objectSpread({
    queryKey: makeQueryKey(['store/store_locations/v1', {
      "long": roundedLongitude,
      lat: roundedLatitude,
      postalCode: postalCode,
      anchor: anchor,
      count: count,
      maxDistance: maxDistance,
      measurementUnits: measurementUnits,
      country: country,
      language: language
    }]),
    queryFn: function queryFn() {
      return fetchStoreLocations({
        longitude: roundedLongitude,
        latitude: roundedLatitude,
        postalCode: postalCode,
        maxDistance: maxDistance,
        measurementUnits: measurementUnits,
        country: country,
        language: language,
        anchor: anchor,
        count: count
      });
    },
    enabled: Boolean(longitude && latitude) || Boolean(postalCode)
  }, select && {
    select: select
  });
};
export default getFetchStoreLocationsOptions;